import React, {useState } from "react";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import { languageOptions } from "../../utils/constants";
import api from "../../services/api.js";
import { useNavigate } from "react-router";
import { SlButton } from "@shoelace-style/shoelace/dist/react";
import { Toast } from "../../shared/Toast";

function PriceCalculator() {
  const navigate = useNavigate();
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [mandalOptions, setMandalOptions] = useState([]);
  const [villageOptions, setVillageOptions] = useState([]);
    const [selectedlocs, setSelectedlocs] = useState([])
    const [price, setPrice] = useState(0)
    const [discountedPrice, setDiscountedPrice] = useState(0)
    const [constituencyOptions, setConstituencyOptions] = useState([]);
  const formik = useFormik({
    initialValues: {
      lang_ids: [],
      state_ids: [],
      district_ids: [],
      mandal_ids: [],
      village_ids: [],
      constituency_ids: [],
    },
    validationSchema: Yup.object({
      lang_ids: Yup.array()
        .required("Language is required")
        .min(1, "Please select atleast one language"),
      state_ids: Yup.array(),
      district_ids: Yup.array(),
      mandal_ids: Yup.array(),
      village_ids: Yup.array(),
      constituency_ids: Yup.array(),
      creative_type: Yup.string(),
    }),
    onSubmit:async(data)=>{
        try {
            const res = await api({
              url: `/user/target/getPrice`,
              method: "POST",
              responseType: "json",
              data: {
                state_ids: data.state_ids,
                district_ids: data.district_ids,
                mandal_ids: data.mandal_ids,
                village_ids: data.village_ids,
                position: data.position || 0,
                lang_ids: data.lang_ids,
                exclude: data.exclude,
                constituency_ids: data.constituency_ids,
                creative_type: data.creative_type
              }
            });
            if (res.code === 200) {
                if(res.data === -1){
                    Toast('error', "Price not available for selected target")
                }
              setPrice(res.data?.price)
            }
           
          } catch (e) {
            console.error(e);
          }
    }
  });
  const lang_idsOnchange = async (selected) => {
    console.log(selected)
    const langs = selected ? (selected).map((item) => item.value) : []
    try {
        let res = await api({
            url: '/location/getStatesByLangId',
            method: 'POST',
            responseType: 'json',
            data: langs
        })
        let states = []
        for await (let item of res.data) {
            const temp = { value: item, label: `${item.state_name}` }
            states.push(temp)
        }
        setStateOptions(states)
        formik.setFieldValue("state_ids", formik.values.state_ids.filter((option) => langs.indexOf(option.lang_id) >= 0))
        formik.setFieldValue("district_ids", formik.values.district_ids.filter((option) => langs.indexOf(option.lang_id) >= 0))
        formik.setFieldValue("constituency_ids", formik.values.constituency_ids.filter((option) => langs.indexOf(option.lang_id) >= 0))
        formik.setFieldValue("mandal_ids", formik.values.mandal_ids.filter((option) => langs.indexOf(option.lang_id) >= 0))
        formik.setFieldValue("village_ids", formik.values.village_ids.filter((option) => langs.indexOf(option.lang_id) >= 0))

    } catch (error) {
        console.error(error);
        if (error.response.status === 401)
            navigate("/")
    }

}
const state_idsOnchange = async (selected, langs) => {
    const states = selected ? (selected).map((item) => { if (item.value) return item.value.state_id }) : []
    // const langs = formik.values.lang_ids
    try {
        let res = await api({
            url: '/location/getDistrictsByStateId',
            method: 'POST',
            responseType: 'json',
            data: { states, langs }
        })
        let districts = []
        for await (let item of res.data) {
            const temp = { value: item, label: `${item.dist_name}` }
            districts.push(temp)
        }
        setDistrictOptions(districts)
        let temp = []
        await formik.setFieldValue("district_ids", formik.values.district_ids.filter((option) => { if (states.indexOf(option.state_id) >= 0) { temp.push(option.dist_id); return true } }))
        formik.setFieldValue("constituency_ids", formik.values.constituency_ids.filter((option) => temp.indexOf(parseInt(option.dist_id)) >= 0))
        formik.setFieldValue("mandal_ids", formik.values.mandal_ids.filter((option) => temp.indexOf(parseInt(option.dist_id)) >= 0))
        formik.setFieldValue("village_ids", formik.values.village_ids.filter((option) => temp.indexOf(option.dist_id) >= 0))

    } catch (error) {
        console.error(error);
        if (error.response.status === 401)
            navigate("/")
    }

}
const district_idsOnchange = async (selected, langs) => {
    const districts = selected ? (selected).map((item) => { if (item.value) return item.value.dist_id }) : []
    try {
        let res = await api({
            url: '/location/getMandalsnew',
            method: 'POST',
            responseType: 'json',
            data: { districts, langs }
        })
        let mandals = []
        for await (let item of res.data) {
            const temp = { value: item, label: `${item.mandal_name}` }
            mandals.push(temp)
        }
        setMandalOptions(mandals)
        let consties = await api({
            url: `/location/getConstituentsnew`,
            method: 'POST',
            responseType: 'json',
            data: {districts, langs}
        })
        let constituents =[]
        for await(let item of consties.data){
            const temp = { value: item, label: `${item.const_name}`}
            constituents.push(temp)
        }
        setConstituencyOptions(constituents)
        formik.setFieldValue("constituency_ids", formik.values.constituency_ids.filter((option) => districts.indexOf(parseInt(option.dist_id)) >= 0))
        formik.setFieldValue("mandal_ids", formik.values.mandal_ids.filter((option) => districts.indexOf(parseInt(option.dist_id)) >= 0))
        formik.setFieldValue("village_ids", formik.values.village_ids.filter((option) => districts.indexOf(parseInt(option.dist_id)) >= 0))

    } catch (error) {
        console.error(error);
        if (error.response.status === 401)
            navigate("/")
    }

}
const mandal_idsOnchange = async (selected, districts, langs, constituency_ids) => {
    const mandals = selected ? (selected).map((item) => { if (item.value) return item.value.mandal_id }) : []
    try {
        //Remove constituency which all mandals are not selected
        if (constituency_ids) {
            const constmandals = mandalOptions.filter(item => formik.values.constituency_ids.map(item => +item.const_id).includes(item.value.const_id))
            let toRemove_consties = constmandals.filter(item => !selected.map(sitem => +sitem.value.mandal_id).includes(item.value.mandal_id)).map(item => item.value.const_id)
            formik.setFieldValue("constituency_ids", constituency_ids.filter(item => !toRemove_consties.includes(item.const_id)))
        }
        let res = await api({
            url: '/location/getVillagesnew',
            method: 'POST',
            responseType: 'json',
            data: { mandals, langs, districts }
        })
        let villages = []
        for await (let item of res.data) {
            const temp = { value: item, label: `${item.village}` }
            villages.push(temp)
        }
        setVillageOptions(villages)
        formik.setFieldValue("village_ids", formik.values.village_ids.filter((option) => mandals.indexOf(option.mandal_id) >= 0))

    } catch (error) {
        console.error(error);
        if (error.response.status === 401)
            navigate("/")
    }

}
const constituency_idsOnchange = async (selected) => {
    if(!formik.values.lang_ids.filter(item => item === 1 || item === 2).length){
        formik.setFieldValue("mandals",[])
        formik.setFieldValue("constituency_ids", [])
        setConstituencyOptions([])
    }
    const consties = selected ? selected.map(item => {if(item.value) return +item.value.const_id}) : []
    const langs = selected ? selected.map(item => {if(item.value) return +item.value.lang_id}) : []
    const formMandals = formik.values.mandal_ids.filter(item => !formik.values.constituency_ids.map(item => +item.const_id).includes(+item.const_id)).map(item => +item.mandal_id)
    let constMandals = mandalOptions.filter(item => consties.includes(+item.value.const_id) || formMandals.includes(+item.value.mandal_id)).map(item => item.value)
    formik.setFieldValue('mandal_ids', constMandals)
    const tempMandal_ids = constMandals.map(item => +item.mandal_id)
    // await formik.setFieldValue('village_ids', formik.values.village_ids.filter(item => tempMandal_ids.includes(+item.mandal_id)))
    if(selected.length){
        await formik.setFieldValue('village_ids',[])
        formik.values.village_ids = []
    }
    mandal_idsOnchange(constMandals.map(item => {return {label: item.mandal_name, value: item}}), formik.values.district_ids.map(item => item.dist_id), formik.values.lang_ids, false)
}
const getvalues = (Array, field) => {
    if (Array.length > 0) {
        switch (field) {
            case "lang_ids":
                return Array.filter((option) => formik.values.lang_ids.indexOf(option.value) >= 0)
            case "state_ids":
                let fun = []
                formik.values.state_ids.map((option) => { fun.push(option.state_id); return null; })
                return Array.filter((option) => fun.indexOf(option.value.state_id) >= 0)
            case "district_ids":
                const res1 = []
                formik.values.district_ids.map((option) => { res1.push(option.dist_id); return null; })
                return Array.filter((option) => res1.indexOf(option.value.dist_id) >= 0)

            case "mandal_ids":
                const res2 = []
                formik.values.mandal_ids.map((option) => { res2.push(option.mandal_id); return null; })
                return Array.filter((option) => res2.indexOf(option.value.mandal_id) >= 0)
            case "village_ids":
                const res3 = []
                formik.values.village_ids.map((option) => { res3.push(option.village_id); return null; })
                return Array.filter((option) => res3.indexOf(option.value.village_id) >= 0)
            case "constituency_ids":
                const res4 = []
                formik.values.constituency_ids.map((option) => { res4.push(option.const_id); return null;})
                return Array.filter((option) => res4.indexOf(option.value.const_id) >= 0)
            // case "pincodes":
            // return Array.filter((option) => formik.values.pincodes.indexOf(option.value) >= 0)

            default:
                return []

        }
    } else {
        return [];
    }
}
const onchange = (selected, field) => {
    if (selected.length === 0)
        setSelectedlocs([])
    formik.setFieldValue(field, selected ? (selected).map((item) => item.value) : []);

}

const handlePercentage = (e) =>{
    let new_price = e.target.value
    if(new_price < 0){
        return
    }
    let percentage = (new_price / price) * 100
    setDiscountedPrice(parseFloat(percentage).toFixed(2))
}

  return (
    <>
      <h5>Price Calculator</h5>
      <div className="mx-auto">
        <form className="contents">
          <div className="mb-3">
            <label htmlFor="" className="form-label">
              Language
            </label>
            <span className="text-red-600">*</span>
            <Select
              // class="form-select"
              aria-label="Default select example"
              name="lang_ids"
              placeholder="select language"
              onBlur={formik.handleBlur}
              value={getvalues(languageOptions, "lang_ids")}
              onChange={(selected) => {
                onchange(selected, "lang_ids");
                lang_idsOnchange(selected);
              }}
              options={languageOptions.slice(0,2)}
              isMulti
            />
            {formik.errors.lang_ids && formik.touched.lang_ids ? (
              <div className="text-red-600">{formik.errors.lang_ids}</div>
            ) : null}
          </div>
          <div>
            <div className="mb-3">
              <label htmlFor="" className="form-label">
                State
              </label>
              <Select
                // class="form-select"
                aria-label="Default select example"
                name="states_ids"
                placeholder="Select States"
                onBlur={formik.handleBlur}
                value={getvalues(stateOptions, "state_ids")}
                onChange={(selected) => {
                  onchange(selected, "state_ids");
                  state_idsOnchange(selected, formik.values.lang_ids);
                }}
                options={stateOptions}
                isMulti
              />
            </div>
            <div className="inline-flex p-2">
              <button
                type="button"
                className="btn btn-primary"
                style={
                  formik.values.exclude === 0
                    ? { backgroundColor: "red", border: "2px solid blue" }
                    : {}
                }
                onClick={(e) => formik.setFieldValue("exclude", 0)}
              >
                {" "}
                {"Include"}
              </button>
              <button
                type="button"
                className="btn btn-primary ml-2"
                style={
                  formik.values.exclude === 1
                    ? { backgroundColor: "red", border: "2px solid blue" }
                    : {}
                }
                onClick={(e) => formik.setFieldValue("exclude", 1)}
              >
                {"Exclude"}
              </button>
            </div>
            <div className="mb-3">
              <label htmlFor="" className="form-label">
                Districts
              </label>
              <Select
                // class="form-select"
                aria-label="Default select example"
                name="district_ids"
                placeholder="Select Districts"
                onBlur={formik.handleBlur}
                value={getvalues(districtOptions, "district_ids")}
                onChange={(selected) => {
                  onchange(selected, "district_ids");
                  district_idsOnchange(selected, formik.values.lang_ids);
                }}
                options={districtOptions}
                isMulti
              />
            </div>
            {formik.values.lang_ids.filter((item) => item === 1 || item === 2)
              .length ? (
              <div className="mb-3">
                <label htmlFor="" className="form-label">
                  Constituency
                </label>
                <Select
                  // class="form-select"
                  aria-label="Default select example"
                  name="constituency_ids"
                  placeholder="Select Constituency"
                  onBlur={formik.handleBlur}
                  value={getvalues(constituencyOptions, "constituency_ids")}
                  onChange={(selected) => {
                    onchange(selected, "constituency_ids");
                    constituency_idsOnchange(selected);
                  }}
                  options={constituencyOptions}
                  isMulti
                />
              </div>
            ) : null}
            <div className="mb-3">
              <label htmlFor="" className="form-label">
                Mandals
              </label>
              <Select
                // class="form-select"
                aria-label="Default select example"
                name="mandal_ids"
                placeholder="Select Mandals"
                onBlur={formik.handleBlur}
                value={getvalues(mandalOptions, "mandal_ids")}
                onChange={(selected) => {
                  onchange(selected, "mandal_ids");
                  mandal_idsOnchange(
                    selected,
                    formik.values.district_ids
                      ? formik.values.district_ids.map((item) => item.dist_id)
                      : [],
                    formik.values.lang_ids,
                    formik.values.constituency_ids
                  );
                }}
                options={mandalOptions}
                isMulti
              />
            </div>
            {formik.values.constituency_ids.length === 0 ? (
              <div className="mb-3">
                <label htmlFor="" className="form-label">
                  Villages
                </label>
                <Select
                  // class="form-select"
                  aria-label="Default select example"
                  name="village_ids"
                  placeholder="Select Villages"
                  onBlur={formik.handleBlur}
                  value={getvalues(villageOptions, "village_ids")}
                  onChange={(selected) => {
                    onchange(selected, "village_ids");
                  }}
                  options={villageOptions}
                  isMulti
                />
              </div>
            ) : null}
          </div>
          <div className="mb-3">
            <label htmlFor="" className="form-label">Position</label>
            <input type="text" className="form-control" name="position" defaultValue={0} value={formik.values.position} onChange={(e) => {formik.handleChange(e); formik.handleSubmit()}} />
            {formik.errors.position && formik.touched.position ? (
              <div className="text-red-600">{formik.errors.position}</div>
            ) : null}
          </div>
          <div className='mb-3'>
                    <label htmlFor="" className="form-label">Creative Type</label>
                    <span className="text-red-600">*</span>
                    <select
                      onBlur={formik.handleBlur}
                      onChange={(e) => { formik.handleChange(e); formik.handleSubmit()}}
                      value={formik.values.creative_type}
                      name="creative_type"
                      
                      className="form-select"
                      aria-label="Default select example">
                      <option value="">select creative type</option>
                      { <><option value="full_image">Full Image</option>
                        <option value="gallery">Gallery Image</option>
                        <option value="full_video">Full Video</option>
                        <option value="half_video">Half Video</option>
                        <option value="promoted_video_story">Promoted Video Story</option>
                        <option value="promoted_image_story">Promoted Image Story</option>
                        <option value="promoted_gallery">Promoted Gallery</option>
                        <option value="fullvideo_or_gif">Full Video or GIF</option>
                        <option value="webviewad">Web View Ad</option></>}
                    

                    </select>
                    {formik.errors.creative_type && (formik.touched.creative_type) ? <div className="text-red-600">{formik.errors.creative_type}</div> : null}
                  </div>
        {/* <div className="mb-3">
            <SlButton variant="primary" className="w-full" type="submit"> Get Price</SlButton>
            </div> */}
        </form>
        <div className="mb-3 d-flex gap-3 justify-center border mx-auto lg:w-1/2 rounded-md p-2 items-center">
            <div className="d-flex gap-2">
            <span className="font-semibold">CardList Price</span>:<span className="font-semibold">{price}</span>
            </div>
            <div className="d-flex gap-2">
                <input className="form-control" type="number" onChange={handlePercentage}></input>
                
            </div>
            <div>
               Actual: {discountedPrice}<span>%</span>
            </div>
            <div>
              Discount: {(100 - discountedPrice).toFixed(2)}%
            </div>
        </div>
      </div>
    </>
  );
}

export default PriceCalculator;
